import { Component, Input } from '@angular/core';
import { PropertyData } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-timer',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.css']
})

export class TimeComponent extends BaseAddOnComponent {

  @Input('input') input: PropertyData;

  constructor() { super(); }

  public getHour(hour: string): void {
    if (isNaN(Number(hour)) || Number(hour) < 0 || hour === '') {
      this.input.MainElementList[0].Value = '00';
    }
  }

  public getMin(min: string): void {
    if (isNaN(Number(min)) || Number(min) < 0 || Number(min) > 59 || min === '') {
      this.input.MainElementList[1].Value = '00';
    }
  }

  public getSec(sec: string): void {
    if (isNaN(Number(sec)) || Number(sec) < 0 || Number(sec) > 59 || sec === '') {
      this.input.MainElementList[2].Value = '00';
    }
  }
}
